// Middleware de autenticación para server functions, seguro para el cliente.
//
// Sustituye al `requireSupabaseAuth` generado en todos los `*.functions.ts`:
// el comportamiento en servidor es el mismo (valida el Bearer, expone
// `context.supabase`, `context.userId`, `context.claims`), pero la
// implementación —y con ella `@supabase/supabase-js`— se carga de forma
// diferida, así no viaja en el bundle de entrada del navegador.
import { createMiddleware } from "@tanstack/react-start";

export const requireSupabaseAuth = createMiddleware({ type: "function" }).server(
  async ({ next }) => {
    const { resolveSupabaseAuthContext } = await import("./require-auth.impl");
    return next({ context: await resolveSupabaseAuthContext() });
  },
);
